import { render, staticRenderFns } from "./PagePickerSheet.vue?vue&type=template&id=1448dea5&scoped=true"
import script from "./PagePickerSheet.vue?vue&type=script&lang=js"
export * from "./PagePickerSheet.vue?vue&type=script&lang=js"
import style0 from "./PagePickerSheet.vue?vue&type=style&index=0&id=1448dea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1448dea5",
  null
  
)

export default component.exports